import React from 'react';
import Footer from "../../navigation/footerContainer";
import SellerDashboardContainer from './sellerDashboard'

export default function SellerDashboardPage(){

    
    return(
        <>
            <SellerDashboardContainer />
            <Footer />
        </>
       
    )
}